import {useEffect} from 'react';

import {INTERACTIVE_ELEMENT_CLASSNAME} from '../utils/consts';
import type {ButtonInfo} from '../types';
import {addButtonInteractivity} from '../../common/utils';
import {WidgetSvg} from './types';

const useButtonInteractivity = (
	svgRootObj: WidgetSvg | undefined,
	canPressButton: boolean,
	setButtonPressedInfo: (arg0: ButtonInfo) => void
) => {
	useEffect(() => {
		if (svgRootObj) {
			// add interactivity to sBox elements
			const interactiveElements = svgRootObj.select(`g.${INTERACTIVE_ELEMENT_CLASSNAME}`);
			interactiveElements?.members.forEach((member) => {
				const assetId = member.attr('id').replace('added_device_', '');
				addButtonInteractivity(member, assetId, canPressButton, setButtonPressedInfo);
			});
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [svgRootObj, canPressButton]);
};

export default useButtonInteractivity;
